import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    Select, Form, Col, Input, Row, Checkbox, Tag, Icon, Spin,
} from 'antd';
import { getBikeModelRequest } from '../redux/actions/get_bike_model.actions';
import { changeBikeModelRequest } from '../redux/actions/change_bike_model.actions';
import { searchByBrandRequest } from '../../BikeManagement/redux/actions/search_by_brand.actions';
import { bike_types, checkboxItemLayout, formItemLayout } from '../../Bike_model_create/components/statics';
import { statics } from '../../BikeManagement/components/statics';
import { history } from '../../../../config/history';

const FormItem = Form.Item; const { Option } = Select; const { TextArea } = Input;
const mapStateToProps = (state) => {
    const { model, loading, filteredBrands } = state.PlatformManagement.Bike_management;
    return { model, loading, filteredBrands };
};

export default connect(mapStateToProps, null)(class BikeConfigure extends PureComponent {
    model_id = history.location.pathname.slice(-24);

    state = {
        inputVisible: false,
        inputValue: '',
        ref_bike_brand: '',
    };

    componentDidMount() {
        this.props.dispatch(getBikeModelRequest(this.model_id));
    }

    handleChange = (value, key) => {
        this.props.dispatch(changeBikeModelRequest(history.location.pathname.slice(-24), key, value));
    };

    handleChangeBrand = (key, value) => {
        this.props.dispatch(changeBikeModelRequest(history.location.pathname.slice(-24), key, value));
        this.setState({ ref_bike_brand: value });
    };

    showInput = () => this.setState({ inputVisible: true }, () => this.input.focus());

    saveInputRef = input => this.input = input;

    handleInputChange = event => this.setState({ inputValue: event.target.value });

    searchByBrand = value => this.props.dispatch(searchByBrandRequest(value));

    handleClose = (removedTag, tags, key) => {
        const value = tags.filter(tag => tag !== removedTag);
        this.props.dispatch(changeBikeModelRequest(history.location.pathname.slice(-24), key, value));
    };

    handleInputConfirm = (key, value) => {
        const { inputValue } = this.state;
        if (inputValue && value.indexOf(inputValue) === -1) {
            value = [...value, inputValue];
            this.props.dispatch(changeBikeModelRequest(history.location.pathname.slice(-24), key, value));
        }
        this.setState({ inputVisible: false, inputValue: '' });
    };

    render() {
        const { model, filteredBrands } = this.props; const
            { inputVisible, inputValue } = this.state;
        return (
            <Fragment>
                {!model
                    ? (
                        <Spin tip="Loading...">
                            <div style={{ minHeight: '60vh' }} />
                        </Spin>
                    )
                    : (
                        <Form style={{ paddingTop: '10px' }} layout="vertical">
                            <Row>
                                <Col span={12}>
                                    <FormItem label="Make" {...formItemLayout}>
                                        <Select
                                            showSearch
                                            value={this.state.ref_bike_brand || model.ref_bike_brand.name}
                                            notFoundContent="No Makes Found"
                                            filterOption={false}
                                            defaultActiveFirstOption={false}
                                            showArrow={false}
                                            onSearch={this.searchByBrand}
                                            onChange={value => this.handleChangeBrand('ref_bike_brand', value)}
                                            placeholder="Select Make"
                                        >
                                            {filteredBrands && filteredBrands.map((brand, index) => <Option key={index} value={brand._id}>{brand.name}</Option>)}
                                        </Select>
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    <FormItem label="We Want Priority" {...formItemLayout}>
                                        <Select
                                            value={model.wwym_priority}
                                            onChange={value => this.handleChange(value, 'wwym_priority')}
                                            placeholder="Select We Want Priority"
                                        >
                                            {statics.bike_priorities.map(pr => <Option key={pr.value}>{pr.label}</Option>)}
                                        </Select>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12}>
                                    <FormItem label="Model Name" {...formItemLayout}>
                                        <Input
                                            onBlur={event => this.handleChange(event.target.value, 'name')}
                                            defaultValue={model.name}
                                        />
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    <FormItem label="Bike Type" {...formItemLayout}>
                                        <Select
                                            value={model.bike_type || 'None'}
                                            onChange={value => this.handleChange(value, 'bike_type')}
                                            placeholder="Select Bike Type"
                                        >
                                            {bike_types.map((type, index) => <Option key={index} value={type.label}>{type.label}</Option>)}
                                        </Select>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12}>
                                    <FormItem label="Engine Size" {...formItemLayout}>
                                        <Input
                                            onBlur={event => this.handleChange(event.target.value, 'cc')}
                                            defaultValue={model.cc}
                                            type="number"
                                            placeholder="Bike CC"
                                        />
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    <FormItem label="Mileage Limit" {...formItemLayout}>
                                        <Select
                                            onChange={value => this.handleChange(value, 'mileage_limit')}
                                            value={model.mileage_limit === 0 ? 'Not Set' : model.mileage_limit}
                                            placeholder="Select Mileage Limit"
                                        >
                                            {statics.bike_mileage_limit.map(limit => <Option key={limit.value}>{limit.label}</Option>)}
                                        </Select>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12}>
                                    <FormItem label="Wet Weight (kg)" {...formItemLayout}>
                                        <Input
                                            defaultValue={model.weight}
                                            onBlur={event => this.handleChange(event.target.value, 'weight')}
                                            placeholder="Weight(kg)"
                                        />
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    <FormItem label="Minimum Age" {...formItemLayout}>
                                        <Select
                                            value={model.min_age === 0 ? 'Not Set' : model.min_age}
                                            onChange={value => this.handleChange(value, 'min_age')}
                                            placeholder="Select Minimum Age"
                                        >
                                            {statics.bike_min_age.map(age => <Option key={age.value}>{age.label}</Option>)}
                                        </Select>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12}>
                                    <FormItem label="Model Variation" {...formItemLayout}>
                                        <Input
                                            value={model.model_variation}
                                            onChange={event => this.handleChange(event.target.value, 'model_variation')}
                                            placeholder="Model Variation"
                                        />
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    <FormItem label="Leadomatic Priority" {...formItemLayout}>
                                        <Select
                                            value={model.leadomatic_priority}
                                            onChange={value => this.handleChange(value, 'leadomatic_priority')}
                                            placeholder="Select Lead-o-matic Priority"
                                        >
                                            {statics.bike_priorities.map(pr => <Option key={pr.value}>{pr.label}</Option>)}
                                        </Select>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <FormItem label="Check Luggage" {...checkboxItemLayout}>
                                        <Checkbox
                                            onChange={event => this.handleChange(event.target.checked, 'check_luggage')}
                                            checked={model.check_luggage}
                                        />
                                    </FormItem>
                                </Col>
                                <Col offset={1} span={5}>
                                    <FormItem label="Price Manually" {...checkboxItemLayout}>
                                        <Checkbox
                                            onChange={event => this.handleChange(event.target.checked, 'always_manual_price')}
                                            checked={model.always_manual_price}
                                        />
                                    </FormItem>
                                </Col>
                                <Col span={6}>
                                    <FormItem label="Check Race Replica" {...checkboxItemLayout}>
                                        <Checkbox
                                            onChange={event => this.handleChange(event.target.checked, 'check_race_replica')}
                                            checked={model.check_race_replica}
                                        />
                                    </FormItem>
                                </Col>
                                <Col offset={1} span={5}>
                                    <FormItem label="We Don`t Want Bike" {...checkboxItemLayout}>
                                        <Checkbox
                                            onChange={event => this.handleChange(event.target.checked, 'we_dont_want')}
                                            checked={model.we_dont_want}
                                        />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12}>
                                    <FormItem label="Alternative Names" {...formItemLayout}>
                                        {model.alternative_names.map(tag => <Tag key={tag} closable style={{ marginBottom: 5 }} afterClose={() => this.handleClose(tag, model.alternative_names, 'alternative_names')}>{tag}</Tag>)}
                                        {inputVisible && (
                                            <Input
                                                ref={this.saveInputRef}
                                                type="text"
                                                size="small"
                                                style={{ width: 78 }}
                                                value={inputValue}
                                                onChange={this.handleInputChange}
                                                onBlur={() => this.handleInputConfirm('alternative_names', model.alternative_names)}
                                                onPressEnter={() => this.handleInputConfirm('alternative_names', model.alternative_names)}
                                            />
                                        )}
                                        {!inputVisible && (
                                            <Tag onClick={this.showInput} style={{ background: '#fff', borderStyle: 'dashed', marginBottom: 5 }}>
                                                <Icon type="plus" style={{ marginBottom: 5 }} />
                                                {' '}
                                                New Name
                                            </Tag>
                                        )}
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row>
                                <Col span={24} className="bikeDescription">
                                    <FormItem label="Bike description" {...formItemLayout}>
                                        <TextArea
                                            rows={4}
                                            defaultValue={model.description}
                                            onBlur={event => this.handleChange(event.target.value, 'description')}
                                            placeholder="Bike description"
                                        />
                                    </FormItem>
                                </Col>
                            </Row>
                        </Form>
                    )}
            </Fragment>
        );
    }
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/components/BikeConfigure.js